exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".buttonMargin-a4f0e{margin-right:24px}", ""]);

// Exports
exports.locals = {
	"buttonMargin": "buttonMargin-a4f0e"
};